import $ from 'jquery'
import Cookies from 'js-cookie'

window.addEventListener('load', function() {

    setTimeout(function() {
        if ( Cookies.get('immoPopupActive') === 1 || Cookies.get('immoPopupActive') === undefined ) {
            var modal = document.getElementById('gsPopup');
            $(modal).modal('show');
        }

    }, 2000);
});


$('#gsPopup').on('hidden.bs.modal', function () {
    $('#gsPopup').html('')
    Cookies.set('immoPopupActive', 0)
});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault()
    window.openAxeptioCookies()
})
